import { Switch } from '@components/index';
import { FormDataType } from '@types';

interface CustomAmountSectionProps {
  formData: FormDataType;
  onCustomAmountEnabledChange: (enabled: boolean) => void;
}

const CustomAmountSection = ({
  formData,
  onCustomAmountEnabledChange
}: CustomAmountSectionProps) => (
  <div className="flex items-start gap-2">
    <Switch
      handleClick={onCustomAmountEnabledChange}
      value={!!formData.paymentInstallment}
    />
    <div className="min-w-0 flex-1 pb-1">
      <span className="text-base font-semibold text-cofeeNeutral10">
        Enable custom / partial amount
      </span>
      <div className="text-sm text-cofeeNeutral7">
        Payers can choose to enter a custom amount or partial amount on the
        review page during payment.
      </div>
    </div>
  </div>
);

export default CustomAmountSection;
